export default __webpack_public_path__ + "static/shield-a66a9c0a1b72411fd166a2069a2ff76f.svg";